import Image from "next/image";
import Link from "next/link";
import clsx from "clsx";
import siteConfig from "../lib/siteConfig";

export default function Logo({ variant = "primary", className = "" }) {
  const src =
    variant === "white"
      ? "/images/sinni-logo-white.svg"
      : "/images/sinni-logo-green.svg";

  return (
    <Link href="/" className={clsx("inline-block", className)}>
      <Image
        src={src}
        alt={siteConfig.siteName}
        width={130}
        height={51}
        className="w-[116px] md:w-[140px] h-auto"
      />
    </Link>
  );
}
